(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cotigo-shipping-bar"] && !Shopify.designMode) return;
  try {
    
function calculate(cart, region) {
  if (!region) return {state:'choose', remaining:null};
  if (!cart || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0) return {state:'unavailable', remaining:null};
  if (cart.currency !== 'EUR' || !Number.isSafeInteger(region.threshold) || region.threshold < 0) return {state:'unavailable', remaining:null};
  if (cart.item_count > 0 && !cart.requires_shipping) return {state:'digital', remaining:null};
  const remaining = Math.max(0, region.threshold - cart.total_price);
  return {state:cart.item_count === 0 ? 'empty' : remaining ? 'remaining' : 'reached', remaining};
}


class CotigoShippingBar extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.config = JSON.parse(this.querySelector('[data-config]').textContent);
    if (this.classList.contains('csb-cart')) {
      const headerConfig = document.querySelector('cotigo-shipping-bar:not(.csb-cart) [data-config]');
      if (headerConfig) this.config.threshold = JSON.parse(headerConfig.textContent).threshold;
    }
    this.message = this.querySelector('[data-message]');
    this.progress = this.querySelector('[data-progress]');
    this.sequence = 0;
    this.onCart = event => {
      this.progress.style.transform = 'scaleX(0)';
      this.cart = null;
      this.sequence++;
      this.message.textContent = this.config.text.loading;
      Promise.resolve(event.promise).then(() => this.refresh(), () => this.refresh());
    };
    ['shopify:cart:lines-update','shopify:cart:discount-update','shopify:cart:view','cart-section:restored'].forEach(name => document.addEventListener(name,this.onCart,{signal:this.controller.signal}));
    window.addEventListener('pageshow', () => this.refresh(), {signal:this.controller.signal});
    document.addEventListener('visibilitychange', () => {if (!document.hidden) this.refresh();}, {signal:this.controller.signal});
    this.refresh();
  }
  disconnectedCallback() {
    this.sequence++;
    this.controller?.abort();
    this.request?.abort();
    this.controller = null;
  }
  async refresh() {
    const sequence = ++this.sequence;
    this.request?.abort();
    this.request = new AbortController();
    try {
      const response = await fetch(this.config.cartUrl, {cache:'no-store',credentials:'same-origin',signal:this.request.signal});
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      if (sequence !== this.sequence || !this.isConnected) return;
      this.cart = cart;
      this.render();
    } catch (error) {
      if (sequence !== this.sequence || error.name === 'AbortError') return;
      this.cart = null;
      this.message.textContent = this.config.text.unavailable;
    }
  }
  render() {
    this.message = this.querySelector('[data-message]');
    this.progress = this.querySelector('[data-progress]');
    const region = {threshold:this.config.threshold};
    const result = calculate(this.cart, region);
    const valid = ['empty','remaining','reached'].includes(result.state);
    const ratio = valid ? (region.threshold > 0 ? Math.min(1, Math.max(0, this.cart.total_price / region.threshold)) : (result.state === 'reached' ? 1 : 0)) : 0;
    this.progress.style.transform = `scaleX(${ratio})`;
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'es', {style:'currency',currency:'EUR'}).format(value/100);
    this.message.textContent = this.config.text[result.state].replace('[amount]',money(result.remaining ?? region?.threshold ?? 0)).replace('[region]',region?.name || '');
  }
}
if (!customElements.get('cotigo-shipping-bar')) customElements.define('cotigo-shipping-bar',CotigoShippingBar);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
